<script>
import Snackbar from './components/Snackbar';

// TODO
// Pouvoir utiliser ESCape sur toutes les modales pour les fermer (directement dans Modale.vue)
// Pouvoir utiliser Enter sur les différents footer des modales pour valider l'action (dans chaque footer, puisque les retours positifs peuvent être différents)

//Désactiver le control + S qui rame de ouf !
document.onkeydown = function (e) {
    e = e || window.event;//Get event

    if (!e.ctrlKey) return;

    var code = e.which || e.keyCode;//Get key code

    switch (code) {
        case 83://Block Ctrl+S
            e.preventDefault();
            e.stopPropagation();
            break;
        case 87://Block Ctrl+W -- Not work in Chrome and new Firefox
            e.preventDefault();
            e.stopPropagation();
            break;
    }
};

export default {
  name: 'App',
  components: {
    Snackbar,
  },

  beforeCreate: function(){   
    //Quelle que soit la page demandée, si je n'ai pas un token valide, je ne rentre pas et je me retrouve au login.
    this.$axios.defaults.headers.common['authorization'] = localStorage.getItem('token')
    this.$axios.get('users/isLoggedIn', {headers: {authorization: localStorage.getItem('token')}})
        .then(response => {
          console.log(response.data);
        })
        .catch(e => {
          console.log("Token " + e.e +" or expired");
          this.$store.dispatch('auth/logout');
          if(this.$route.path != "/") {
            this.$router.push('/');
          }
        });
  },
}
</script>

<template>
  <div id="app">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <router-view id="menu-view" name="menu"></router-view>
    <router-view id="main-view" name="main"></router-view>
    <Snackbar id="snackbarPosition"/>

  </div>
</template>

<style lang="scss">
@import './assets/main.scss';
@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap');


#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  // justify-content: center;
  align-items: flex-start;
  height: 100vh;
}

#main-view{
  flex:1;
  // border: green solid 10px;
  min-height: 101vh;
  // display: flex;
  // justify-content: center;
}

#snackbarPosition{
  position: fixed;
  bottom: 2vh;
  right: 2vw;
  z-index: 100;
}

</style>
